<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        ref="searchItem"
        config-module="9211"
        :is-simple-query="false"
        :custom-sim-query-placeholder="$t('CargoMsg.Cargo_PlsInput') + ':' + ($t('SeaExport.OrderNo2'))"
        :custom-search-items="customSearchItems"
        @click-more="value=>{isAdvancedQuery=value}"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="queryHandler"
      >
        <div slot="operations">
          <el-button v-if="source === SystemConstants.LOAD_POOL_SOURCE_HOME_PAGE.code" type="primary" @click="generateAssemblyPlan">{{ $t('CargoMsg.Cargo_GenerateAssemblyPlan') }}</el-button>
          <el-button v-if="source === SystemConstants.LOAD_POOL_SOURCE_DETAIL.code" type="primary" @click="addUldItemsToUld">{{ $t('CargoMsg.Cargo_AddToPlan') }}</el-button>
        </div>
      </search-item>
      <div style="flex-grow: 1;min-height: 350px;">
        <cargo-ag-grid-wrapper
          config-module="202206072"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :show-selected-color="false"
          :check-sub-record="false"
          style="height: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="202206072"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
    </div>
    <assembly-plan-dialog
      v-if="assemblyPlanDialog.visible"
      :visible.sync="assemblyPlanDialog.visible"
      :form="assemblyPlanDialog.form"
      :airline-product-down-list="airlineProductDownList"
      @saveAssemblyPlanSuccess="saveAssemblyPlanSuccess"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as RadioStatusConstants from '@/class/cargo/model/parameters/RadioStatusConstants'
import airlineProductVoyage from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyage'
import airlineProductVoyageCost from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyageCost'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { queryLoadPool } from '@/api/booking/assemblyPlan'
import { AssemblyPlan } from '@/class/model/booking/AssemblyPlan'
import { AssemblyPlanUld } from '@/class/model/booking/AssemblyPlanUld'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import assemblyPlanDialog from '@/views/cargo/v0/AirExport/components/loadManagement/assemblyPlanDialog'
import CargoAgGridAssemblyEditor from '@/components/Cargo/Common/CargoAgGridAssemblyEditor/index'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import {
  CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL,
  CUBAGE_NOT_ASSEMBLY_LABEL,
  QUANTITY_NOT_ASSEMBLY_LABEL,
  WEIGHT_NOT_ASSEMBLY_LABEL
} from '@/class/cargo/model/parameters/SystemConstants'
import AssemblyPlanUtils from '@/utils/AssemblyPlanUtils'
import { isEqual } from 'lodash'

export default {
  name: 'LoadPool',
  components: { cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, cargoInputNumber,
    cargoNumericStepper, airlineProductVoyage, airlineProductVoyageCost, assemblyPlanDialog },
  props: {
    airlineProductDownList: { type: Array, default: () => [] },
    source: { type: String, default: '' } // 首页/详情
  },
  data() {
    return {
      SystemConstants, RadioStatusConstants,
      loading: false,
      TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      customSearchItems: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAssemblyEditor,
          CargoAgGridColumnEditGroup
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        }
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.MasterBillNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SeparateNumber'),
          field: 'hawb',
          colId: 'hawb',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.OrderNo2'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RouteConfirmationStatus'),
          colId: 'routeConfirmationStatus',
          field: 'routeConfirmationStatus',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.ROUTE_CONFIRMATION_LIST) // 航线确认状态
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceProduct'),
          field: 'serviceProduct',
          colId: 'serviceProduct',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirServiceProduct, 'productId', params.value, 'productName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineProductCode'),
          field: 'airlineProductUuid',
          colId: 'airlineProductUuid',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.getAirLineProductLabelFunc(params.value, this.airlineProductDownList)
          }
        }, {
          headerName: this.$t('SeaExport.InBatchesOrNot'),
          field: 'isAssembly', // 是否 拼装过
          colId: 'isAssembly',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, RadioStatusConstants.YES_NO_TYPES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NotAssemblyQuantity'),
          field: 'quantityNotAssemblyLabel',
          colId: 'quantityNotAssemblyLabel',
          maxWidth: 500,
          minWidth: 300,
          editable: () => true,
          cellEditor: 'CargoAgGridAssemblyEditor',
          cellEditorParams: {
            field: 'quantityNotAssemblyLabel',
            valueChanged: this.assemblyInfoChange
          },
          onCellValueChanged: this.assemblyInfoChange
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NotAssemblyGrossWeight'),
          field: 'weightNotAssemblyLabel',
          colId: 'weightNotAssemblyLabel',
          maxWidth: 500,
          minWidth: 300,
          editable: () => true,
          cellEditor: 'CargoAgGridAssemblyEditor',
          cellEditorParams: {
            field: 'weightNotAssemblyLabel',
            valueChanged: this.assemblyInfoChange
          },
          onCellValueChanged: this.assemblyInfoChange
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NotAssemblyVolume'),
          field: 'cubageNotAssemblyLabel',
          colId: 'cubageNotAssemblyLabel',
          maxWidth: 500,
          minWidth: 300,
          editable: () => true,
          cellEditor: 'CargoAgGridAssemblyEditor',
          cellEditorParams: {
            field: 'cubageNotAssemblyLabel',
            valueChanged: this.assemblyInfoChange
          },
          onCellValueChanged: this.assemblyInfoChange
        },
        {
          headerName: this.$t('CargoMsg.Cargo_NotAssemblyChargeableWeight'),
          field: 'chargeWeightNotAssemblyLabel',
          colId: 'chargeWeightNotAssemblyLabel',
          maxWidth: 500,
          minWidth: 300,
          editable: () => true,
          cellEditor: 'CargoAgGridAssemblyEditor',
          cellEditorParams: {
            field: 'chargeWeightNotAssemblyLabel',
            valueChanged: this.assemblyInfoChange
          },
          onCellValueChanged: this.assemblyInfoChange
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Density_Weight'),
          field: 'density',
          colId: 'density',
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OriginPort'),
          field: 'portOfDeparture',
          colId: 'portOfDeparture',
          width: 100
          // cellRenderer: (params) => {
          //   return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'chineseName')
          // }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          colId: 'destinationPortCode',
          width: 100
          // cellRenderer: (params) => {
          //   return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'chineseName')
          // }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Airline2'),
          field: 'carrierId',
          colId: 'carrierId',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          hide: true
        }, {
          headerName: this.$t('SeaExport.FlightNo'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 100
        },
        { headerName: this.$t('CargoMsg.Cargo_FlightDate'), field: 'etd', width: 180, colId: 'etd',
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.BackUpWarehouse'),
          colId: 'frontEndWarehouseOperation',
          field: 'frontEndWarehouseOperation',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirportCargoTerminal, 'uuid', params.value, 'warehouseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeliveryCargoStation'),
          colId: 'cargoTerminalOperation',
          field: 'cargoTerminalOperation',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirportCargoTerminal, 'uuid', params.value, 'warehouseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreWarehouseStatus'),
          colId: 'warehouseStatus',
          field: 'warehouseStatus',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_WarehouseInState$WAREHOUSE_STATE, 'code', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DeliveryStatus'),
          colId: 'deliveryStatus',
          field: 'deliveryStatus',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.DELIVERY_STATUS)
          }
        },
        { headerName: this.$t('SeaExport.Sales'), field: 'sales', width: 180, colId: 'sales',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales') : ''
          },
          hide: true
        },
        { headerName: this.$t('SeaExport.CustomerService'), field: 'csr', width: 180, colId: 'csr',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr') : ''
          },
          hide: true
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 180, colId: 'op',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op') : ''
          },
          hide: true
        }
      ],
      rowData: [],
      selectedRows: [],
      gridApi: null,
      assemblyPlanDialog: {
        visible: false,
        form: new AssemblyPlan().fillDefaultValue().getData()
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  watch: {
    airlineProductDownList: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0 && !isEqual(newVal, oldVal)) {
          // 初始化 自定义 高级查询
          this.customSearchItems = this.getCustomSearchItems()
        }
      }
    }
  },
  created() {
    this.queryHandler()
    this.init()
  },
  methods: {
    init() {
      // 初始化 自定义 高级查询
      this.customSearchItems = this.getCustomSearchItems()
    },
    calculationDimension(params) {
      const data = params.data
      data.quantity = data.sizeQuantity || 0
      data.dimension = (data.sizeLength || 0) + '*' + (data.sizeWidth || 0) + '*' + (data.sizeHeight || 0) + '*' + (data.sizeQuantity || 0)
      data.quantityNotAssembly2 = data.dimension
      data.cubage = (data.sizeLength / 100) * (data.sizeWidth / 100) * (data.sizeHeight / 100) * data.sizeQuantity
      const value = JobUtils.calcCubageQuantity(data.dimension)
      if (value) {
        data.cubage = NumberUtils.roundHalfUp(value[0], 3)
      }
      this.gridApi.refreshCells({ force: true })
    },
    assemblyInfoChange(params) {
      if (params.colDef.field === QUANTITY_NOT_ASSEMBLY_LABEL.code) {
        params.data.quantityNotAssemblyLabel = ColumnUtils.getNotAssemblyInfoLabel(params.data.quantityNotAssembly, params.data.quantityAssembly, params.data.quantity)
      } else if (params.colDef.field === WEIGHT_NOT_ASSEMBLY_LABEL.code) {
        params.data.weightNotAssemblyLabel = ColumnUtils.getNotAssemblyInfoLabel(params.data.weightNotAssembly, params.data.weightAssembly, params.data.weight)
      } else if (params.colDef.field === CUBAGE_NOT_ASSEMBLY_LABEL.code) {
        params.data.cubageNotAssemblyLabel = ColumnUtils.getNotAssemblyInfoLabel(params.data.cubageNotAssembly, params.data.cubageAssembly, params.data.cubage)
      } else if (params.colDef.field === CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL.code) {
        params.data.chargeWeightNotAssemblyLabel = ColumnUtils.getNotAssemblyInfoLabel(params.data.chargeWeightNotAssembly, params.data.chargeWeightAssembly, params.data.chargeWeight)
      }
      this.gridApi.refreshCells({ force: true })
    },
    getCustomSearchItems() {
      const defaultSearchFields = []
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'aeJob.AIRLINE_PRODUCT_UUID'
      searchField.itemLabel = 'CargoMsg.Cargo_AirlineProductCode'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.tagName = 'name'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = this.airlineProductDownList
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    setSelectValue(obj) {
      this.airlineProductDialog.form[obj.key] = obj.value
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (!keyword) {
      // 覆盖原查询条件
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + (this.$t('SeaExport.OrderNo2')))
        return
      }
      const data = [new AdvancedSearchOption(null, 'JOB_NO', keyword, 'LIKE').formatObj2Json()]
      this.queryHandler(data)
    },
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryLoadPool(this.filter).then(res => {
        this.rowData = res.data.list
        if (this.rowData && this.rowData.length > 0) {
          this.rowData.forEach(row => {
            row.quantityNotAssemblyLabel = ColumnUtils.getNotAssemblyInfoLabel(row.quantityNotAssembly, row.quantityAssembly, row.quantity)
            row.weightNotAssemblyLabel = ColumnUtils.getNotAssemblyInfoLabel(row.weightNotAssembly, row.weightAssembly, row.weight)
            row.cubageNotAssemblyLabel = ColumnUtils.getNotAssemblyInfoLabel(row.cubageNotAssembly, row.cubageAssembly, row.cubage)
            row.chargeWeightNotAssemblyLabel = ColumnUtils.getNotAssemblyInfoLabel(row.chargeWeightNotAssembly, row.chargeWeightAssembly, row.chargeWeight)
          })
        }
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.selectedRows = []
      }).finally(() => {
        this.loading.close()
      })
    },
    // 计划生成之后 跳转计划详情页签
    saveAssemblyPlanSuccess(assemblyPlanUuid) {
      this.queryHandler()
      this.$emit('saveAssemblyPlanSuccess', assemblyPlanUuid)
    },
    // 生成 拼装计划
    generateAssemblyPlan() {
      this.assemblyPlanDialog.form = new AssemblyPlan().fillDefaultValue().getData()
      const form = this.assemblyPlanDialog.form
      form.assemblyPlanUlds = [new AssemblyPlanUld().fillDefaultValue().getData()]
      const rows = this.gridApi.getSelectedRows()
      if (rows && rows.length > 0) {
        // 校验 不允许 件/毛/体/计 为0
        const errorRow = rows.find(p => !p.quantityNotAssembly || !p.weightNotAssembly || !p.cubageNotAssembly || !p.chargeWeightNotAssembly ||
          p.quantityNotAssembly <= 0 || p.weightNotAssembly <= 0 || p.cubageNotAssembly <= 0 || p.chargeWeightNotAssembly <= 0)
        if (errorRow) {
          this.$message.warning(this.$t('CargoMsg.Cargo_FieldsCannotBeEmpty'))
          return
        }
        form.assemblyPlanUlds[0].assemblyPlanUldItems = rows
        // 初始化 拼装计划-基本信息
        const row = rows[0]
        form.airlineProductUuid = row.airlineProductUuid
        form.flightNumber = row.voyageFlight
        form.flightDate = row.etd
        form.portOfDeparture = row.portOfDeparture
        form.destinationPortCode = row.destinationPortCode
        form.cargoTerminalOperation = row.cargoTerminalOperation
        // 【出仓指令】 出仓状态 有一条是‘否’则【不可出仓】，都是‘是’则【可出仓】
        form.outboundInstruction = row.outboundInstruction
        AssemblyPlanUtils.bringDataFromAirlineProduct(this.airlineProductDownList, form)
        // // 根据 【航线产品】 带出
        // if (this.airlineProductDownList && this.airlineProductDownList.length > 0) {
        //   const airlineProduct = this.airlineProductDownList.find(p => p.uuid === form.airlineProductUuid)
        //   if (airlineProduct) {
        //     // 根据 【航线产品】 带出【服务产品、航司】
        //     form.serviceProduct = row.serviceProduct
        //     form.carrierId = row.carrierId
        //   }
        // }
        // // 根据 【航线产品-航次】 带出
        // const productVoyage = AssemblyPlanUtils.getProductVoyage(this.airlineProductDownList, form)
        // if (productVoyage) {
        //   // 根据 【航线产品-航次】 带出 【限重、理论体积】
        //   form.basicWeight = productVoyage.basicWeight || 0.0
        //   form.limitWeight = productVoyage.limitWeight || 0.0
        //   form.availableCabinSpace = productVoyage.availableCabinSpace || 0.0
        //   form.theoryVolume = productVoyage.theoryVolume || 0.0
        //   form.sellableVolume = productVoyage.sellableVolume || 0.0
        //   // 根据 【航线产品】 带出 【成本】
        //   if (productVoyage.voyageCosts && productVoyage.voyageCosts.length > 0) {
        //     const assemblyPlanCosts = deepClone(productVoyage.voyageCosts)
        //     assemblyPlanCosts.forEach(p => {
        //       p.uuid = null
        //     })
        //     form.assemblyPlanCosts = assemblyPlanCosts
        //   }
        // }
      }
      this.assemblyPlanDialog.visible = true
    },
    addUldItemsToUld() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
      } else {
        this.$emit('addUldItemsToUld', this.selectedRows)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .input-label {
    display: inline-block;
    width: 60px;
    color: #666666;
  }
  .el-form{
    /deep/ .el-input__inner{
      width: 300px;
    }
  }
</style>
